import { render } from "./EtiquetasEscolares.vue?vue&type=template&id=eb12e8d0&scoped=true"
import script from "./EtiquetasEscolares.vue?vue&type=script&lang=js"
export * from "./EtiquetasEscolares.vue?vue&type=script&lang=js"

import "./EtiquetasEscolares.vue?vue&type=style&index=0&id=eb12e8d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb12e8d0"]])

export default __exports__